import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import TradingSection from '../components/TradingSection';
import IndustrialPlatform from '../components/IndustrialPlatform';
import WhyUs from '../components/WhyUs';
import Partnership from '../components/Partnership';
import Team from '../components/Team';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

export default function HomePage() {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      <Header onCTA={scrollToContact} />
      <Hero onGetInTouch={scrollToContact} />
      <About />
      <TradingSection />
      <IndustrialPlatform />
      <Partnership />
      <WhyUs />
      <Team />
      <Contact />
      <Footer />
    </div>
  );
}
